import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const BASE = `${API_BASE_URL}/payment-rails`;

export class PaymentRailsApi {
  static getCatalog = () => axios.get(`${BASE}/catalog`);

  static list = (paymentRailSettingId) =>
    axios.get(BASE, {
      params: { payment_rail_setting_id: paymentRailSettingId },
    });

  static get = (id) => axios.get(`${BASE}/${id}`);

  static create = (data) => axios.post(BASE, data);

  static update = (id, data) => axios.put(`${BASE}/${id}`, data);

  static delete = (id) => axios.delete(`${BASE}/${id}`);
}
